import { Component, Input } from '@angular/core';
import { AuditTrialDetails } from '../../../../../shared/models/audits/audit-trial-details';
import { ActionItemTransitionDetails } from '../models/action-item-transition-details';
import { ActionItemLifeCycle } from '../models/action-item-life-cycle';
import { ActionItemAuditTrialDetails } from '../models/action-item-audit-trial-details';
import { ActionItemAuditService } from '../services/action-item-audit.service';
import { SharedConstants } from '../../../../../shared/constants/shared-constants';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-action-item-audit-trial',
  templateUrl: './action-item-audit-trial.component.html',
  styleUrls: ['./action-item-audit-trial.component.scss']
})
export class ActionItemAuditTrialComponent {
  @Input() actionItemNumber: string = '';
  auditAttributeDetailsOfTransaction!: AuditTrialDetails;
  actionItemTransitionDetails!: ActionItemTransitionDetails;
  actionItemLifeCycleDetails: ActionItemLifeCycle[] = [];
  actionItemAuditSummaryDetails: ActionItemAuditTrialDetails[] = [];
  showLoader: boolean = false;
  isActionItemAuditDetailsDataLoaded = false;
  constructor(private actionItemAuditService: ActionItemAuditService, private messageService: MessageService) {

  }
  ngOnInit(): void {
    this.showLoader = true
    this.actionItemAuditService.getActionItemTransitionDetails(this.actionItemNumber)
      .subscribe({
        next: (actionItemTransitionDetails) => {
          this.actionItemTransitionDetails = actionItemTransitionDetails;
          this.actionItemLifeCycleDetails = actionItemTransitionDetails.actionItemLifeCycleDetails;
          this.actionItemAuditSummaryDetails = actionItemTransitionDetails.actionItemAuditTrialDetails;
          this.auditAttributeDetailsOfTransaction = actionItemTransitionDetails.actionItemAuditTrialDetails[0];
          this.isActionItemAuditDetailsDataLoaded = true;
          this.notifyMissingAttributesIfAny();
          this.showLoader = false;
        },
        error: (error) => {
          this.messageService.add({
            severity: SharedConstants.Severity_Error,
            summary: SharedConstants.Audit_Fail_Error_Message,
            sticky: true
          });
          this.showLoader = false;
        }
      });
  }
  showAuditItemDetails = (auditAttributeDetails: any) => {
    this.auditAttributeDetailsOfTransaction = auditAttributeDetails;
  }

  private hasMissingAttributes(): boolean {
    const summary = this.actionItemAuditSummaryDetails;
    return !!summary?.some(d => d?.attributeDetails?.some(a => a?.isAttributeValueMissing));
  }
  private notifyMissingAttributesIfAny(): void {
    if (this.hasMissingAttributes()) {
      this.messageService.add({
        severity: SharedConstants.Severity_Warning,
        summary: SharedConstants.AuditTrail_AttributeMissing_Message,
        life: 20000,
      });
    }
  }
}
